const ServiceHighlights = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold mb-4">Why Choose ZiwaTech ?</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            We offer professional repair services with quality parts, skilled technicians, and warranty on all repairs.
          </p>
        </div>
    
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Highlight 1 */}
          <div className="text-center p-6 rounded-lg bg-white shadow-sm">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary text-white mb-4">
              <i className="fas fa-tools text-2xl"></i>
            </div>
            <h3 className="text-xl font-semibold mb-2 text-primary">Expert Technicians</h3>
            <p className="text-gray-600">
              Our certified repair specialists have years of experience fixing all types of devices.
            </p>
          </div>

         
          {/* Highlight 2 */}
          <div className="text-center p-6 rounded-lg bg-white shadow-sm">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary text-white mb-4">
              <i className="fas fa-clock text-2xl"></i>
            </div>
            <h3 className="text-xl font-semibold mb-2 text-primary">Quick Turnaround</h3>
            <p className="text-gray-600">
              Most repairs are completed same-day, often while you wait.
            </p>
          </div>

          {/* Highlight 3 */}
          <div className="text-center p-6 rounded-lg bg-white shadow-sm">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary text-white mb-4">
              <i className="fas fa-shield-alt text-2xl"></i>
            </div>
            <h3 className="text-xl font-semibold mb-2 text-primary">Warranty Included</h3>
            <p className="text-gray-600">
              All repairs include parts and service.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceHighlights;
